import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {getStorefrontProducts, StorefrontProductItem} from "../api/payment";

export const fetchWaterdropProductsAsync = createAsyncThunk(
    'waterdrop/fetchProducts',
    async () => {
        return await getStorefrontProducts();
    }
);

interface WaterdropState {
    products: StorefrontProductItem[];
    loading: boolean;
}

const initialState: WaterdropState = {
    products: [],
    loading: false
};

export const waterdropSlice = createSlice({
    name: 'waterdrop',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchWaterdropProductsAsync.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchWaterdropProductsAsync.fulfilled, (state, action) => {
                state.products = action.payload;
                state.loading = false;
            })
            .addCase(fetchWaterdropProductsAsync.rejected, (state) => {
                state.loading = false;
            });
    },
});

export default waterdropSlice.reducer;
